import React from 'react';
import styles from './ProgressBar.module.css';

class ProgressBar extends React.Component {
    render() {
        let {
            percent,
            bgColor,
            progressColor
        } = this.props;

        return (
            <div className={styles.progressBar} style={{ backgroundColor: bgColor }}>
              <div className={"progress-loading-bar " + styles.progress } style={{ width: `${ percent * 100 }%`, backgroundColor: progressColor }} />
            </div>
        )
    }
}

ProgressBar.defaultProps = {
  percent: 0,
  bgColor: 'gray',
  progressColor: 'green'
}

export default ProgressBar
